import React from 'react'
// https://github.com/SheetJS/js-xlsx
// https://sheetjs.com/
import XLSX from 'xlsx'

import Btn from '../Btn/Btn'

export default class ExcelModeloBuilder extends React.Component {
  // Props: { modeloColunas, filename }

  // modeloColunas: É Array de Array - ATENÇÃO
  /* EXEMPLO */
  // const modeloColunas = [
  //   ["S", "h", "e", "e", "t", "J", "S"],
  //   [1, 2, 3, 4, 5]
  // ];

  onBtnClick = () => {
    const { modeloColunas, filename } = this.props
    const wb = XLSX.utils.book_new()
    var ws_name = 'Modelo'

    const ws_data = modeloColunas
    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    /* Add the worksheet to the workbook */
    XLSX.utils.book_append_sheet(wb, ws, ws_name)

    const write_opts = {
      type: 'base64',
    }
    XLSX.writeFile(wb, filename, write_opts)
  }
  render() {
    return <Btn onClick={this.onBtnClick}>Baixar Modelo</Btn>
  }
}
